module.exports = __webpack_public_path__ + "media/images/sp/page_common/icon/icon_prev_navy-cbb1095bab328f32370564d5155a2ef2.svg";